import { IState, TAction } from './types'

export function reducer(state: IState, action: TAction): IState {
  switch (action.type) {
    case 'SET_INITIAL_LISTS':
      return {
        ...state,
        availableList: action.available,
        activeList: action.active,
      }

    case 'MOVE_ALL_TO_ACTIVE':
      return {
        ...state,
        activeList: [...state.activeList, ...state.availableList],
        availableList: [],
        checkedAvailable: [],
      }

    case 'MOVE_ALL_TO_AVAILABLE':
      return {
        ...state,
        availableList: [...state.availableList, ...state.activeList],
        activeList: [],
        checkedActive: [],
      }

    case 'MOVE_AVAILABLE_TO_ACTIVE': {
      const newActive = state.availableList.filter((item) =>
        state.checkedAvailable.includes(item.id),
      )
      return {
        ...state,
        activeList: [...state.activeList, ...newActive],
        availableList: state.availableList.filter(
          (item) => !state.checkedAvailable.includes(item.id),
        ),
        checkedAvailable: [],
      }
    }

    case 'MOVE_ACTIVE_TO_AVAILABLE': {
      const newAvailable = state.activeList.filter((item) => state.checkedActive.includes(item.id))
      return {
        ...state,
        availableList: [...state.availableList, ...newAvailable],
        activeList: state.activeList.filter((item) => !state.checkedActive.includes(item.id)),
        checkedActive: [],
      }
    }

    case 'TOGGLE_CHECK': {
      const listKey = action.list === 'activeList' ? 'checkedActive' : 'checkedAvailable'
      const currentList = state[listKey]
      const exists = currentList.includes(action.id)
      const newList = exists
        ? currentList.filter((id) => id !== action.id)
        : [...currentList, action.id]

      return {
        ...state,
        [listKey]: newList,
      }
    }

    case 'SELECT_ALL_ACTIVE':
      if (action.event.target.checked) {
        return {
          ...state,
          checkedActive: state.activeList.map((item) => item.id),
        }
      } else {
        return {
          ...state,
          checkedActive: [],
        }
      }

    case 'SELECT_ALL_AVAILABLE':
      if (action.event.target.checked) {
        return {
          ...state,
          checkedAvailable: state.availableList.map((item) => item.id),
        }
      } else {
        return {
          ...state,
          checkedAvailable: [],
        }
      }

    case 'DRAG_END':
      if (action.oldIndex !== action.newIndex) {
        let newList = [...state.activeList]
        if (action.list === 'activeList') {
          newList = [...state.activeList]
        } else {
          newList = [...state.availableList]
        }
        const [movedItem] = newList.splice(action.oldIndex, 1)
        newList.splice(action.newIndex, 0, movedItem)
        if (action.list === 'activeList') {
          return {
            ...state,
            activeList: newList,
          }
        } else {
          return {
            ...state,
            availableList: newList,
          }
        }
      }
      return state

    default:
      console.error('Unhandled action type:', action)
      return state
  }
}

export const initialState: IState = {
  availableList: [],
  activeList: [],
  checkedAvailable: [],
  checkedActive: [],
}
